import { Fetcher } from '@design-stack-ct/assets-sdk';
import { SHERBERT_URL } from '../utilities/constants';
const fetcher = Fetcher.for(SHERBERT_URL);
/**
 * Gets all the sun tenant specified by the given tenantId.
 */
export const getSubTenant = fetcher.path('/v2/tenants/{tenantId}').method('get').create();
//# sourceMappingURL=SherbertService.js.map